

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import { pathwayTypeInfoType } from '@/types/Information';

@Component
export default class DecisionOnLeaveToAppealRspToLeavePg extends Vue {  

    @informationState.Action
    public UpdatePathType!:(newPathType: pathwayTypeInfoType) => void

    public appLeaveGrantedPath() {

        const pathType = {} as pathwayTypeInfoType;
        pathType.appLeaveGranted = true;
        this.UpdatePathType(pathType);
        this.$emit('closeWindow');        

    }

    public appLeaveRefusedPath() {

        const pathType = {} as pathwayTypeInfoType;
        pathType.appLeaveRefused = true;
        this.UpdatePathType(pathType); 
        this.$emit('closeWindow');
    }
}
